import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DowntrendLineIcon, UptrendLineIcon } from '~/assets/icons';

type CardProps = {
  title: string;
  icon: React.ReactNode;
  content: string;
  percent: number;
  type: 'up' | 'down';
  onClick?: () => void;
};

const Card = (props: CardProps) => {
  const { title, content, percent, icon, type, onClick } = props;

  //#region Declare Hook
  const { t } = useTranslation('admin/dashboard');
  //#endregion Declare Hook

  return (
    <Box
      onClick={onClick}
      className={`px-[20px] py-[16px] border-[1px] border-[#E5EAEF] rounded-[8px] ${
        onClick ? 'cursor-pointer hover:bg-gray-50' : ''
      }`}
    >
      <Box className='flex justify-between items-center'>
        <Box className='text-[14px]/[16.8px] font-medium text-[#898989]'>{title}</Box>
        <Box className='h-[40px] w-[40px] border-[0.71px] border-[#E6E6E6] rounded-full flex items-center justify-center'>
          {icon}
        </Box>
      </Box>
      <Box className='mt-[5px] text-[32px]/[40px] font-semibold text-[#3A3F51] h-[40px]'>{content}</Box>
      <Box className='mt-[10px] font-normal text-[14px]/[16.8px] text-[#606060]'>
        <Box className='inline-block'>
          {type === 'up' ? <UptrendLineIcon className='w-[31px]' /> : <DowntrendLineIcon className='w-[41px]' />}
        </Box>
        <span className={`font-semibold ml-[10px] ${type === 'up' ? 'text-[#4AD991]' : 'text-[#ED544E]'}`}>
          {percent}%
        </span>{' '}
        {t('vsPreviousMonth')}
      </Box>
    </Box>
  );
};

export default Card;
